import { atom } from "recoil"

export const listPlanRequestIdState = atom({
  key: "atoms/paidTeam/listPlanRequestIdState",
  default: 0,
})
